import { InvoiceDocumentType } from '../../../enums/invoiceDocumentType'
import { getInvoiceQueryKey } from '../../../utils/getInvoiceQueryKey'
import { getQuoteQueryKey } from '../../../utils/getQuoteQueryKey'

interface ShareDocumentQueryProps {
  id?: string
  type?: InvoiceDocumentType
}

export const getShareDocumentQueryKey = ({ id, type }: ShareDocumentQueryProps) => {
  if (!id || !type) {
    return []
  }

  if (type === InvoiceDocumentType.Quote) {
    return getQuoteQueryKey(id)
  }

  return getInvoiceQueryKey(id, type)
}
